import { render, staticRenderFns } from "./folders-important-files.vue?vue&type=template&id=3a982430&scoped=true"
import script from "./folders-important-files.vue?vue&type=script&lang=js"
export * from "./folders-important-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a982430",
  null
  
)

export default component.exports